import React, { useState } from "react";

const CarRentalPricing = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-4xl font-bold text-center mb-6">🚘 Car Rental Pricing & Terms</h1>
      
      {/* Pricing Table */}
      <div className="overflow-x-auto bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Rental Pricing (CFA)</h2>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-3">Rental Duration</th>
              <th className="p-3">Economy</th>
              <th className="p-3">Standard</th>
              <th className="p-3">Luxury</th>
              <th className="p-3">SUV/4x4</th>
            </tr>
          </thead>
          <tbody>
            {["Hourly", "Daily", "Weekly", "Monthly", "Weekend (Fri-Sun)"].map((duration, index) => (
              <tr key={index} className="border-b">
                <td className="p-3 font-medium">{duration}</td>
                <td className="p-3">{[5000, 25000, 150000, 500000, 60000][index]}</td>
                <td className="p-3">{[7000, 35000, 200000, 650000, 85000][index]}</td>
                <td className="p-3">{[12000, 60000, 350000, 1200000, 140000][index]}</td>
                <td className="p-3">{[15000, 80000, 450000, 1500000, 180000][index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Rental Terms & Conditions */}
      <div className="mt-8 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4">📜 Rental Terms & Conditions</h2>
        {[
          { title: "✅ General Terms", content: "Minimum age: 21+ for Standard & Economy, 25+ for Luxury & SUVs. Valid driver’s license required. Security deposit applies." },
          { title: "⛽ Fuel Policy", content: "Full-to-full policy: Return with a full tank. Missing fuel will be charged at 1,500 CFA per missing liter." },
          { title: "🚗 Mileage Limits", content: "Daily rentals: 200 km/day, extra 500 CFA/km. Weekly & Monthly rentals: Unlimited mileage." },
          { title: "📅 Cancellation Policy", content: "Free cancellation if done 48+ hours before pickup. 50% charge within 24 hours. No refund for same-day cancellations or no-shows." },
          { title: "🔧 Additional Services & Fees", content: "Chauffeur service: 10,000/day. GPS: 5,000/day. Child seat: 3,000/day. Additional driver: 7,000/day." }
        ].map((item, index) => (
          <div key={index} className="border-b py-3">
            <button
              className="w-full text-left text-lg font-semibold flex justify-between"
              onClick={() => toggleSection(index)}
            >
              {item.title}
              <span>{openSection === index ? "🔼" : "🔽"}</span>
            </button>
            {openSection === index && <p className="mt-2 text-gray-700">{item.content}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarRentalPricing;
